import React, { useState, useEffect } from "react";
import "./AboutUs.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import AboutUs from "../../assets/aboutus.jpg";
import Modal from "../Modal/Modal";

const Reasons = () => {
  const [showModal, setShowModal] = useState(false);
  const [alignItems, setAlignItems] = useState("start");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 440) {
        setAlignItems("center");
      } else {
        setAlignItems("start");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //Por si en algun momento se necesita llamar al modal, se agrega la function y en el boton se agrega onClick={handleContactClick}

  // const handleContactClick = () => {
  //   setShowModal(true);
  // };
  return (
    <>
      <div className="container-r">
        <div className="container">
          <Container>
            <Row className="pt-5 pb-5 grid-direction-a">
              <Col>
                <p className={`text-light text-${alignItems} fs-2 mt-4`}>
                  ¿Quienes Somos?
                </p>
                <p className={`text-light text-${alignItems} mt-5`}>
                  En VPEX, nos enorgullece ser una empresa joven y dinámica que
                  se especializa en el desarrollo de aplicaciones web a medida y
                  la creación de páginas web innovadoras. Somos apasionados por
                  la tecnología y comprometidos con ofrecer soluciones digitales
                  que impulsen el éxito de nuestros clientes.
                </p>
                <p className={`text-light text-${alignItems}`}>
                  Con un enfoque centrado en la personalización, trabajamos
                  estrechamente con nuestros clientes para entender sus
                  necesidades y objetivos específicos. Nuestro equipo de
                  expertos en desarrollo web utiliza las últimas tecnologías y
                  prácticas de vanguardia para construir soluciones que no solo
                  cumplen, sino que superan las expectativas.
                </p>
                <p className={`text-light text-${alignItems}`}>
                  En nuestra travesía, ya hemos puesto en producción dos
                  productos de éxito: un software diseñado especialmente para
                  gimnasios, facilitando la gestión y optimizando sus
                  operaciones; y una solución integral para sodas y empresas de
                  venta de agua, simplificando los procesos y mejorando la
                  eficiencia.
                </p>
                <p className={`text-light text-${alignItems}`}>
                  En VPEX, no solo creamos tecnología; construimos experiencias
                  digitales que transforman negocios y hacen avanzar a la
                  sociedad. Únete a nosotros en este emocionante viaje hacia el
                  futuro digital.
                </p>
              </Col>
              <Col
                flex-column
                className="col-lg-5 col-md-6 text-center img-align-a"
              >
                <Image src={AboutUs} fluid className="img-r" />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Modal show={showModal} setShow={setShowModal} />
    </>
  );
};

export default Reasons;
